import React from 'react';
import { X } from 'lucide-react';

/**
 * Tag-style multi-select. "me" renders as "Myself"; removing every tag means
 * "everyone I can see".
 * @param {{agents: Array<{_id: string, name?: string, email?: string}>, value: string[],
 *   onChange: (ids: string[]) => void}} props
 * @returns {JSX.Element}
 */
export default function AgentMultiSelect({ agents, value, onChange }) {
  const label = (id) => (id === 'me' ? 'Myself' : (agents.find((a) => String(a._id) === id)?.name || 'Agent'));
  const options = [
    ...(value.includes('me') ? [] : [{ _id: 'me', name: 'Myself' }]),
    ...agents.filter((a) => !value.includes(String(a._id))),
  ];
  return (
    <div className="flex items-center gap-2 flex-wrap border border-civix-border rounded-md px-2 py-1.5 bg-civix-panelLight/60 min-w-[260px]">
      {value.map((id) => (
        <span key={id} className="inline-flex items-center gap-1 bg-white/10 rounded px-2 py-0.5 text-xs">
          {label(id)}
          <button type="button" onClick={() => onChange(value.filter((v) => v !== id))} aria-label={`Remove ${label(id)}`}>
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      <select
        value=""
        onChange={(e) => e.target.value && onChange([...value, e.target.value])}
        aria-label="Add agent"
        className="flex-1 min-w-[90px] bg-transparent text-xs text-white/60 outline-hidden"
      >
        <option value="">{value.length ? 'Add agent…' : 'All visible agents'}</option>
        {options.map((a) => <option key={String(a._id)} value={String(a._id)} className="text-black">{a.name || a.email}</option>)}
      </select>
    </div>
  );
}
